import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "gatsby-plugin-react-i18next";
import { useLocation } from "@reach/router";
import { useStaticQuery, graphql } from "gatsby";
import { useTranslation } from "gatsby-plugin-react-i18next";

const Seo = ({ title, description, image, article, children, titleTemplate }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const query = graphql`
    query Seo {
      site {
        siteMetadata {
          titleTemplate
          siteUrl
          defaultImage: image
          twitterUsername
        }
      }
    }
  `;
  const { site } = useStaticQuery(query);

  const { titleTemplate: defaultTitleTemplate, siteUrl, defaultImage, twitterUsername } = site.siteMetadata;
  const defaultTitle = t(`ComExpertise.store | e-commerce solutions`);
  const defaultDescription = t(`ComExpertise est une Entreprise de Services du Numérique localisée dans l'ouest de la France.`);

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: `${siteUrl}${image || defaultImage}`,
    url: `${siteUrl}${pathname}`,
    titleTemplate: titleTemplate || defaultTitleTemplate,
  };

  // @see https://github.com/nfl/react-helmet#example
  return (
    <Helmet title={seo.title} titleTemplate={seo.titleTemplate}>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />

      {seo.url && <meta property="og:url" content={seo.url} />}

      {(article ? true : null) && <meta property="og:type" content="article" />}

      {seo.title && <meta property="og:title" content={seo.title} />}

      {seo.description && <meta property="og:description" content={seo.description} />}

      {seo.image && <meta property="og:image" content={seo.image} />}

      <meta name="twitter:card" content="summary_large_image" />

      {twitterUsername && <meta name="twitter:creator" content={twitterUsername} />}

      {seo.title && <meta name="twitter:title" content={seo.title} />}

      {seo.description && <meta name="twitter:description" content={seo.description} />}

      {seo.image && <meta name="twitter:image" content={seo.image} />}

      {children}
    </Helmet>
  );
};

Seo.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  article: PropTypes.bool,
  titleTemplate: PropTypes.string,
};

Seo.defaultProps = {
  title: null,
  description: null,
  image: null,
  article: false,
  titleTemplate: null,
};

export default Seo;
